import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'next/router';
import styled from 'styled-components';
import _isEmpty from 'lodash/isEmpty';
import { TEMPLATE as PAGE_COMPONENT_KEY_TEMPLATE } from 'constants/pagesComponentsKeys';
import * as templateKeys from 'routes/template/constants/templateKeys';
import fetchTemplateData from 'state/template/operations/fetchTemplateData';
import { setCurrentPageComponent } from 'state/currentPageComponent/actions';
import { resetState } from 'state/template/actions';
import { setTransitionToCheckout } from 'state/templates/hotel/actions';
import trackEventEmpty from 'managers/gtmEventTracking/utils/trackEventEmpty';
import Spinner from 'routes/template/components/Spinner';
import AdvertsTemplate from 'routes/template/templates/adverts/AdvertsTemplate';
import CountriesTemplate from 'routes/template/templates/countries/CountriesTemplate';
import CountryTemplate from 'routes/template/templates/country/CountryTemplate';
import CustomerServiceTemplate from 'routes/template/templates/customerService/CustomerServiceTemplate';
import CoronaVirusTemplate from 'routes/template/templates/coronaVirus/CoronaVirusTemplate';
import DefaultTemplate from 'routes/template/templates/default/DefaultTemplate';
import DestinationTemplate from 'routes/template/templates/destination/DestinationTemplate';
import LandingPageTemplate from 'routes/template/templates/landingPage/LandingPageTemplate';
import ThemeTemplate from 'routes/template/templates/theme/ThemeTemplate';
import ThemesListTemplate from 'routes/template/templates/themesList/ThemesListTemplate';
import CookieTemplate from 'routes/template/templates/cookies/CookieTemplate';

class Template extends Component {
  componentDidMount() {
    const { router, template, setCurrentPageComponent, fetchTemplateData, setTransitionToCheckout } = this.props;
    setCurrentPageComponent(PAGE_COMPONENT_KEY_TEMPLATE);
    setTransitionToCheckout(false);

    if (template.shouldFetchData) {
      fetchTemplateData(router.asPath);
    } else {
      trackEventEmpty();
    }
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.template.redirect !== null) {
      this.props.fetchTemplateData(nextProps.template.redirect);
      return false;
    }

    if (nextProps.template.template === templateKeys.HOTEL) {
      return false;
    }

    return true;
  }

  componentDidUpdate(prevProps) {
    const { router, template, fetchTemplateData } = this.props;
    const { router: prevRouter } = prevProps;

    if (router.asPath !== prevRouter.asPath && router.asPath !== template.slug) {
      fetchTemplateData(router.asPath);
    }

    trackEventEmpty();
  }

  componentWillUnmount() {
    const { template, resetState } = this.props;

    if (template.template !== templateKeys.HOTEL) {
      resetState();
    }
  }

  render() {
    const { template, content } = this.props.template;

    if (_isEmpty(content)) {
      return <Spinner />;
    }

    return <Root>{getTemplate(template, content)}</Root>;
  }
}

function mapStateToProps(state) {
  return {
    template: state.template,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setCurrentPageComponent(routeName) {
      dispatch(setCurrentPageComponent(routeName));
    },
    fetchTemplateData(pathname) {
      dispatch(fetchTemplateData(pathname));
    },
    resetState() {
      dispatch(resetState());
    },
    setTransitionToCheckout(transitionToCheckout) {
      dispatch(setTransitionToCheckout(transitionToCheckout));
    },
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Template));

const Root = styled.div`
  position: relative;
  line-height: 1.6rem;
`;

function getTemplate(template, content) {
  switch (template) {
    case templateKeys.COUNTRIES:
      return <CountriesTemplate content={content} />;

    case templateKeys.COUNTRY:
      return <CountryTemplate content={content} />;

    case templateKeys.DESTINATION:
      return <DestinationTemplate content={content} />;

    case templateKeys.AIRLINE_LANDINGPAGE:
      return <LandingPageTemplate content={content} />;

    case templateKeys.THEMES:
      return <ThemesListTemplate content={content} />;

    case templateKeys.THEME:
      return <ThemeTemplate content={content} />;

    case templateKeys.ADVERTS:
      return <AdvertsTemplate content={content} />;

    case templateKeys.CUSTOMER_SERVICE:
      return <CustomerServiceTemplate content={content} />;

    case templateKeys.CORONA_VIRUS:
      return <CoronaVirusTemplate content={content} />;

    case templateKeys.COOKIES:
      return <CookieTemplate content={content} />;

    default:
      return <DefaultTemplate content={content} />;
  }
}
